import React from 'react';

export function arrayOrderForSelect(items: Array<any>) {
  const result = items?.map((item: any) => {
    return { text: item.name, value: item.id };
  });
  return result;
}
